import getAppletPath from '../../../utils/create-url';

export default {
  name: 'Location',
  edit: {
    form: 'applet-input',
    label: 'Edit Location Applet',
    handler: value => value,
    getAltEditLink: (parent) => {
      const searchParams = new URLSearchParams();
      searchParams.set('property', 'location');
      const pathname = `/${getAppletPath(parent)}/~create/Place`;
      return {
        label: 'Add a Place',
        pathname,
        search: `?${searchParams.toString()}`,
        state: {
          presets: {
            name: 'Location',
            description: `Location for ${parent.name}`,
          },
        },
      };
    },
  },
};
